export const DashboardMenuEnum = {
    Payroll: "Payroll",
    UpcomingLeave: "Upcoming leave",
    // Reimbursement: "Reimbursement"
};